<template>
  <div class="page">
    <div class="dataContent">
    <el-table
          border
          size="small"
          :data="dataList"
          :span-method="objectSpanMethod"
          tooltip-effect="dark"
          style="width: 100%">
          <template slot="empty">
            <emptyView style="margin:10px">
            </emptyView>
          </template>
          <el-table-column
            prop="functionName"
            label="功能名称">
          </el-table-column>
          <el-table-column
            prop="topicClass"
            label="设备的Topic列表">
          </el-table-column>
           <el-table-column
            label="设备具有的权限">
            <template slot-scope="scope">
              <div>
                {{authority[scope.row.operateAuth]?authority[scope.row.operateAuth]:''}}
                <span class="upDevice" v-if="(scope.row.topicType === 2 || scope.row.topicType === 3) && scope.row.operateAuth !== 2" @click="downDir(scope.row)">
                  下发指令
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="messageNumber"
            label="发布的消息数">
          </el-table-column>
          <el-table-column
            label="是否已订阅">
            <template slot-scope="scope">
              <div>
                {{scope.row.isSubscribe?'是':'否'}}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Directive @dialog="dialog" v-if="dialogFlag" :dialogFlag="dialogFlag" :rowData="rowData" :deviceDetail="deviceDetail" @closeAddDialog="closeAddDialog"/>
  </div>
</template>
<script>
import emptyView from '@/components/empty_view/empty'
import Directive from './downDirective'
import { deviceTopic } from '@/api/deviceManagement'
export default {
  props: {
    deviceDetail: {
      type: Object
    }
  },
  components: {
    emptyView,
    Directive
  },
  data () {
    return {
      dataList: [],
      activeName: '0',
      authority: {
        1: '订阅',
        2: '发布',
        3: '发布和订阅'
      }, // 设备具有的权限
      topicData: {
        allData: null,
        subData: null
      },
      spanArr: [], // 用于存放每一行记录的合并数
      dialogFlag: false,
      rowData: {}
    }
  },
  methods: {
    downDir (row) {
      this.dialogFlag = true
      this.rowData = row
    },
    getDeviceTopic () {
      const params = {
        deviceName: this.deviceDetail.deviceName,
        productKey: this.deviceDetail.productKey
      }
      deviceTopic(params).then(res => {
        res = res.data
        const objData = res.data
        Object.keys(objData).forEach(key => {
          objData[key].forEach(item => {
            this.dataList.push(item)
          })
        })
        this.getSpanArr(this.dataList)
        // this.dataList = res.data
      })
    },
    getSpanArr (data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1)
          this.pos = 0
        } else {
        // 判断当前元素与上一个元素是否相同
          if (data[i].functionName === data[i - 1].functionName) {
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    // 合并行
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        // console.log(`rowspan:${_row} colspan:${_col}`)
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col
        }
      }
    },
    closeAddDialog () {
      this.dialogFlag = false
    },
    dialog (val) {
      this.dialogFlag = val
    }
  },
  created () {
    this.getDeviceTopic()
  }
}
</script>
<style lang="less" scope>
.page{
  .title{
    margin-bottom: 10px;
    font-weight: bold;
  }
  .showAll{
      display: flex;
      align-items: center;
      span{
        color: #f0bd95;
      }
    }
    .tableContent{
        margin-top: 20px;
        /deep/ .el-tabs__item.is-active{
          color: #FFF;
          background-color: #0092cc;
        }
      }
  .upDevice{
    cursor: pointer;
    color: #00a3cc;
  }
}
</style>
